import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

export default function About() {
  const { t } = useLanguage();
  const a = t.about;

  return (
    <section id="about" className="py-24 md:py-32 lg:py-40 border-b border-line">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-auroraDeep mb-6">{a.label}</p>
          <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            {a.titlePrefix}<span className="font-serif-accent italic font-medium">{a.titleHighlight}</span>
          </h2>
          <p className="mt-8 max-w-2xl text-lg font-light text-stone leading-relaxed">
            {a.intro}
          </p>
        </Reveal>

        <div className="mt-20 space-y-0">
          {a.journey.map((stage, i) => {
            const isLast = i === a.journey.length - 1;
            return (
              <Reveal key={stage.n} delay={i * 0.08}>
                <div className="group grid md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-t border-line items-start">
                  <div className="md:col-span-3">
                    <span className={`font-display font-extrabold text-6xl md:text-7xl text-line transition-colors duration-500 group-hover:text-auroraDeep`}>{stage.n}</span>
                    <p className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-stone mt-3">{a.stageLabel} {stage.n}</p>
                    <h3 className="font-display font-bold text-3xl md:text-4xl mt-2">{stage.title}</h3>
                  </div>
                  <div className="md:col-span-9">
                    <p className={`font-serif-accent italic text-2xl md:text-3xl leading-tight mb-5 text-auroraDeep`}>
                      {stage.tagline}
                    </p>
                    <p className="text-lg font-light text-stone leading-relaxed max-w-2xl">{stage.body}</p>
                    <p className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-stone mt-8 mb-3">{stage.label}</p>
                    <div className="flex flex-wrap gap-2">
                      {stage.items.map((it) => (
                        <span key={it} className={`font-mono-tech text-[11px] uppercase tracking-wider border px-3 py-1.5 transition-colors duration-300 ${isLast ? "border-aurora/50 text-ink hover:bg-aurora/15" : "border-line text-stone hover:border-ink hover:text-ink"}`}>
                          {it}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <motion.blockquote
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-24 max-w-4xl font-serif-accent italic text-3xl md:text-5xl leading-tight"
          data-testid="about-quote"
        >
          &ldquo;{a.quote}&rdquo;
        </motion.blockquote>
      </div>
    </section>
  );
}
